import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const YoutubeMusicService = {
  actions: {
    fetchAllYoutubeMusic ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/musics',
          method: 'GET'
        })
          .then(resp => {
            const youtubeMusics = resp.data.youtubeMusics
            commit('api_success')
            resolve(resp)
            return youtubeMusics
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    createYoutubeMusic ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/music',
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    deleteYoutubeMusic ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/music/' + id,
          method: 'delete'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    editYoutubeMusic ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/music/' + data.get('id'),
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    fetchYoutubeMusic ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/music/' + id,
          method: 'GET'
        })
          .then(resp => {
            const youtubeMusic = resp.data.youtubeMusic
            commit('api_success')
            resolve(resp)
            return youtubeMusic
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    }
  }
}

export default YoutubeMusicService



// WEBPACK FOOTER //
// ./src/services/youtubeMusicService.js